import React, { memo } from 'react'
import ProductCategoryTable from './ProductCategoryTable'

const ProductCategoryTab: React.FC = memo(() => {
    return (
        <ProductCategoryTable />
    )
})

ProductCategoryTab.displayName = 'ProductCategoryTab'

export default ProductCategoryTab